import { render, staticRenderFns } from "./QuestionsProfils.vue?vue&type=template&id=9d956a20&scoped=true"
import script from "./QuestionsProfils.vue?vue&type=script&lang=js"
export * from "./QuestionsProfils.vue?vue&type=script&lang=js"
import style0 from "./QuestionsProfils.vue?vue&type=style&index=0&id=9d956a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d956a20",
  null
  
)

export default component.exports